import { timeMeasurement } from '@pkg/utils';

export const tokens = {
    color: {
        bg: '#090719',
        layer1: '#052dff',
        layer2: '#9105ff',
        layer3: '#16d5ff',
        layer4: '#07048a',
        layer5: '#ed254e',
        layer6: '#9c0c7c',
        layer7: {
            stop1: '#17acff',
            stop2: '#b645eb',
            stop3: '#ffe7dd',
            stop4: '#e87c82',
        },
    },
    duration: {
        interior: 60 * timeMeasurement.msPerSec,
        layer: 40 * timeMeasurement.msPerSec,
    },
};
